import React from "react";
import Login from "./pages/login";
import DriversPage from "./pages/list-drivers";
import PassengersPage from "./pages/list-passengers";
import TripsPage from "./pages/list-services";
import { Routes, Route } from "react-router-dom";
import AdminsPage from "./pages/list-admins";
import ListCoupons from "./pages/coupons";
import CampaignsPage from "./pages/coupon-campaigns";
import NotFound from "./pages/not-found";
import PageHome from "./pages/home";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/profile";
import DynamicRoutes from "./pages/dynamic-route";
import AppStatusPage from "./pages/app-status";
import CancellationsPage from "./pages/cancellations";
import WhitelistPage from "./pages/whitelist";
import RecoveryDriver from "./pages/recovery-driver";
import MonitoreoPage from "./pages/monitoreo";

const AppRoutes = () => {
  return (
    <>
      {/* URLs principales */}
      <Routes>
        <Route path={"login"} exact element={<Login />} />
        <Route path={"recuperar-conductor"} exact element={<RecoveryDriver />} />
        <Route path={"/"} element={<PageHome />}>
          {/* CONTENIDO DE LA PAGINA */}
          <Route path={"dashboard"} exact element={<Dashboard />} />
          <Route path={"viajes"} exact element={<TripsPage />} />
          <Route path={"pasajeros"} exact element={<PassengersPage />} />
          <Route path={"conductores"} exact element={<DriversPage />} />
          <Route path={"administradores"} exact element={<AdminsPage />} />
          <Route path={"cupones"} exact element={<ListCoupons />} />
          <Route path={"campanas"} exact element={<CampaignsPage />} />
          <Route path={"perfil"} exact element={<Profile />} />
          <Route path={"rutas-dinamicas"} exact element={<DynamicRoutes />} />
          <Route path={"estado-app"} exact element={<AppStatusPage />} />
          <Route path={"cancelaciones"} exact element={<CancellationsPage />} />
          <Route path={"whitelist"} exact element={<WhitelistPage />} />
          <Route path={"monitoreo"} exact element={<MonitoreoPage />} />
          {/* URL NOT FOUND */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
